// import React, { useEffect, useState } from "react";
// import {
//   Button, Dialog, DialogActions, DialogContent, DialogTitle,
//   FormControlLabel, Grid, MenuItem, Switch, TextField
// } from "@mui/material";
// import { menuApi } from "../utils/menuApi";

// const defaultForm = {
//   node_type: "item",
//   parent_item: "",
//   name: "",
//   description: "",
//   image_url: "",
//   is_available: true,
//   is_veg: true,
//   tags: "",
//   ingredients: "",
//   rating: "",
//   rating_count: "",
//   prep_time_minutes: "",
//   calories: "",
//   badge: "",
//   pickup: "",
//   delivery: "",
//   dine_in: "",
//   discount_type: "",
//   discount_value: "",
//   display_order: 1,
// };

// const ItemDialog = ({
//   open, mode, data, token, clientId, locationId, foodType, category, onClose, onSuccess, showSnackbar,
// }) => {
//   const [form, setForm] = useState(defaultForm);

//   useEffect(() => {
//     if (data) {
//       setForm({
//         node_type: data.node_type || "item",
//         parent_item: data.parent_item || "",
//         name: data.name || "",
//         description: data.description || "",
//         image_url: data.image_url || "",
//         is_available: data.is_available ?? true,
//         is_veg: data.is_veg ?? true,
//         tags: Array.isArray(data.tags) ? data.tags.join(", ") : "",
//         ingredients: Array.isArray(data.ingredients) ? data.ingredients.join(", ") : "",
//         rating: data.rating || "",
//         rating_count: data.rating_count || "",
//         prep_time_minutes: data.prep_time_minutes || "",
//         calories: data.calories || "",
//         badge: data.badge || "",
//         pickup: data.pricing?.pickup ?? "",
//         delivery: data.pricing?.delivery ?? "",
//         dine_in: data.pricing?.dine_in ?? "",
//         discount_type: data.discount_type || "",
//         discount_value: data.discount_value ?? "",
//         display_order: data.display_order ?? 1,
//       });
//     } else {
//       setForm(defaultForm);
//     }
//   }, [data, open]);

//   const handleSave = async () => {
//     const payload = {
//       node_type: form.node_type,
//       parent_item: form.parent_item || null,
//       name: form.name,
//       description: form.description,
//       image_url: form.image_url,
//       is_available: form.is_available,
//       is_veg: form.is_veg,
//       tags: form.tags ? form.tags.split(",").map((x) => x.trim()).filter(Boolean) : [],
//       ingredients: form.ingredients ? form.ingredients.split(",").map((x) => x.trim()).filter(Boolean) : [],
//       rating: form.rating ? Number(form.rating) : null,
//       rating_count: form.rating_count ? Number(form.rating_count) : null,
//       prep_time_minutes: form.prep_time_minutes ? Number(form.prep_time_minutes) : null,
//       calories: form.calories ? Number(form.calories) : null,
//       badge: form.badge || "",
//       pricing:
//         form.node_type === "item_group"
//           ? null
//           : {
//               pickup: form.pickup === "" ? null : Number(form.pickup),
//               delivery: form.delivery === "" ? null : Number(form.delivery),
//               dine_in: form.dine_in === "" ? null : Number(form.dine_in),
//             },
//       discount_type: form.discount_type || "",
//       discount_value: form.discount_value === "" ? null : Number(form.discount_value),
//       display_order: Number(form.display_order || 1),
//     };

//     try {
//       if (mode === "edit" && data?.id) {
//         await menuApi.updateItem({
//           token,
//           clientId,
//           locationId,
//           foodTypeId: foodType.id,
//           categoryId: category.id,
//           itemId: data.id,
//           payload,
//         });
//         showSnackbar("Item updated successfully");
//       } else {
//         await menuApi.createItem({
//           token,
//           clientId,
//           locationId,
//           foodTypeId: foodType.id,
//           categoryId: category.id,
//           payload,
//         });
//         showSnackbar("Item created successfully");
//       }
//       onSuccess();
//       onClose();
//     } catch (error) {
//       showSnackbar(error?.response?.data?.detail || "Failed to save item", "error");
//     }
//   };

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
//       <DialogTitle>{mode === "edit" ? "Edit Item" : "Add Item"}</DialogTitle>
//       <DialogContent>
//         <Grid container spacing={2} sx={{ mt: 0.5 }}>
//           <Grid item xs={12} sm={4}>
//             <TextField select fullWidth label="Node Type" value={form.node_type} onChange={(e) => setForm((p) => ({ ...p, node_type: e.target.value }))}>
//               <MenuItem value="item">Item</MenuItem>
//               <MenuItem value="item_group">Item Group</MenuItem>
//             </TextField>
//           </Grid>

//           <Grid item xs={12} sm={8}>
//             <TextField fullWidth label="Parent Item ID (only for sub-item)" value={form.parent_item} onChange={(e) => setForm((p) => ({ ...p, parent_item: e.target.value }))} />
//           </Grid>

//           <Grid item xs={12} sm={6}><TextField fullWidth label="Name" value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} /></Grid>
//           <Grid item xs={12} sm={6}><TextField fullWidth label="Badge" value={form.badge} onChange={(e) => setForm((p) => ({ ...p, badge: e.target.value }))} /></Grid>
//           <Grid item xs={12}><TextField fullWidth label="Description" value={form.description} onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))} /></Grid>
//           <Grid item xs={12}><TextField fullWidth label="Image URL" value={form.image_url} onChange={(e) => setForm((p) => ({ ...p, image_url: e.target.value }))} /></Grid>
//           <Grid item xs={12}><TextField fullWidth label="Tags (comma separated)" value={form.tags} onChange={(e) => setForm((p) => ({ ...p, tags: e.target.value }))} /></Grid>
//           <Grid item xs={12}><TextField fullWidth label="Ingredients (comma separated)" value={form.ingredients} onChange={(e) => setForm((p) => ({ ...p, ingredients: e.target.value }))} /></Grid>

//           <Grid item xs={12} sm={3}><TextField fullWidth type="number" label="Pickup Price" value={form.pickup} disabled={form.node_type === "item_group"} onChange={(e) => setForm((p) => ({ ...p, pickup: e.target.value }))} /></Grid>
//           <Grid item xs={12} sm={3}><TextField fullWidth type="number" label="Delivery Price" value={form.delivery} disabled={form.node_type === "item_group"} onChange={(e) => setForm((p) => ({ ...p, delivery: e.target.value }))} /></Grid>
//           <Grid item xs={12} sm={3}><TextField fullWidth type="number" label="Dine-in Price" value={form.dine_in} disabled={form.node_type === "item_group"} onChange={(e) => setForm((p) => ({ ...p, dine_in: e.target.value }))} /></Grid>
//           <Grid item xs={12} sm={3}><TextField fullWidth type="number" label="Display Order" value={form.display_order} onChange={(e) => setForm((p) => ({ ...p, display_order: e.target.value }))} /></Grid>

//           <Grid item xs={12} sm={3}><TextField fullWidth type="number" label="Rating" value={form.rating} onChange={(e) => setForm((p) => ({ ...p, rating: e.target.value }))} /></Grid>
//           <Grid item xs={12} sm={3}><TextField fullWidth type="number" label="Rating Count" value={form.rating_count} onChange={(e) => setForm((p) => ({ ...p, rating_count: e.target.value }))} /></Grid>
//           <Grid item xs={12} sm={3}><TextField fullWidth type="number" label="Prep Time (mins)" value={form.prep_time_minutes} onChange={(e) => setForm((p) => ({ ...p, prep_time_minutes: e.target.value }))} /></Grid>
//           <Grid item xs={12} sm={3}><TextField fullWidth type="number" label="Calories" value={form.calories} onChange={(e) => setForm((p) => ({ ...p, calories: e.target.value }))} /></Grid>

//           <Grid item xs={12} sm={4}>
//             <TextField select fullWidth label="Discount Type" value={form.discount_type} onChange={(e) => setForm((p) => ({ ...p, discount_type: e.target.value }))}>
//               <MenuItem value="">None</MenuItem>
//               <MenuItem value="flat">Flat</MenuItem>
//               <MenuItem value="percentage">Percentage</MenuItem>
//             </TextField>
//           </Grid>
//           <Grid item xs={12} sm={4}><TextField fullWidth type="number" label="Discount Value" value={form.discount_value} onChange={(e) => setForm((p) => ({ ...p, discount_value: e.target.value }))} /></Grid>
//           <Grid item xs={12} sm={4}>
//             <FormControlLabel control={<Switch checked={form.is_available} onChange={(e) => setForm((p) => ({ ...p, is_available: e.target.checked }))} />} label="Available" />
//             <FormControlLabel control={<Switch checked={form.is_veg} onChange={(e) => setForm((p) => ({ ...p, is_veg: e.target.checked }))} />} label="Veg" />
//           </Grid>
//         </Grid>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose}>Cancel</Button>
//         <Button variant="contained" onClick={handleSave}>Save</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default ItemDialog;


import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  MenuItem,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { menuApi } from "../utils/menuApi";

const defaultForm = {
  node_type: "item",
  parent_item: "",
  name: "",
  description: "",
  image: null,
  is_available: true,
  is_veg: true,
  tags: "",
  ingredients: "",
  rating: "",
  rating_count: "",
  prep_time_minutes: "",
  calories: "",
  badge: "",
  pickup: "",
  delivery: "",
  dine_in: "",
  discount_type: "",
  discount_value: "",
  display_order: 1,
};

const ItemDialog = ({
  open,
  mode,
  data,
  token,
  clientId,
  locationId,
  foodType,
  category,
  onClose,
  onSuccess,
  showSnackbar,
}) => {
  const [form, setForm] = useState(defaultForm);

  useEffect(() => {
    if (data) {
      setForm({
        node_type: data.node_type || "item",
        parent_item: data.parent_item || "",
        name: data.name || "",
        description: data.description || "",
        image: null,
        is_available: data.is_available ?? true,
        is_veg: data.is_veg ?? true,
        tags: Array.isArray(data.tags) ? data.tags.join(", ") : "",
        ingredients: Array.isArray(data.ingredients) ? data.ingredients.join(", ") : "",
        rating: data.rating || "",
        rating_count: data.rating_count || "",
        prep_time_minutes: data.prep_time_minutes || "",
        calories: data.calories || "",
        badge: data.badge || "",
        pickup: data.pricing?.pickup ?? "",
        delivery: data.pricing?.delivery ?? "",
        dine_in: data.pricing?.dine_in ?? "",
        discount_type: data.discount_type || "",
        discount_value: data.discount_value ?? "",
        display_order: data.display_order ?? 1,
      });
    } else {
      setForm(defaultForm);
    }
  }, [data, open]);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0] || null;
    setForm((prev) => ({
      ...prev,
      image: file,
    }));
  };

  const handleSave = async () => {
    if (!form.name.trim()) {
      showSnackbar("Name is required", "error");
      return;
    }

    const payload = new FormData();
    payload.append("node_type", form.node_type);
    payload.append("parent_item", form.parent_item || "");
    payload.append("name", form.name);
    payload.append("description", form.description || "");
    payload.append("is_available", String(form.is_available));
    payload.append("is_veg", String(form.is_veg));
    payload.append("rating", form.rating ? String(Number(form.rating)) : "");
    payload.append(
      "rating_count",
      form.rating_count ? String(Number(form.rating_count)) : ""
    );
    payload.append(
      "prep_time_minutes",
      form.prep_time_minutes ? String(Number(form.prep_time_minutes)) : ""
    );
    payload.append("calories", form.calories ? String(Number(form.calories)) : "");
    payload.append("badge", form.badge || "");
    payload.append("discount_type", form.discount_type || "");
    payload.append(
      "discount_value",
      form.discount_value === "" ? "" : String(Number(form.discount_value))
    );
    payload.append("display_order", String(Number(form.display_order || 1)));

    const tags = form.tags
      ? form.tags.split(",").map((x) => x.trim()).filter(Boolean)
      : [];
    const ingredients = form.ingredients
      ? form.ingredients.split(",").map((x) => x.trim()).filter(Boolean)
      : [];

    payload.append("tags", JSON.stringify(tags));
    payload.append("ingredients", JSON.stringify(ingredients));

    if (form.node_type !== "item_group") {
      payload.append(
        "pricing",
        JSON.stringify({
          pickup: form.pickup === "" ? null : Number(form.pickup),
          delivery: form.delivery === "" ? null : Number(form.delivery),
          dine_in: form.dine_in === "" ? null : Number(form.dine_in),
        })
      );
    }

    if (form.image) {
      payload.append("image", form.image);
    }

    try {
      if (mode === "edit" && data?.id) {
        await menuApi.updateItem({
          token,
          clientId,
          locationId,
          foodTypeId: foodType.id,
          categoryId: category.id,
          itemId: data.id,
          payload,
        });
        showSnackbar("Item updated successfully");
      } else {
        await menuApi.createItem({
          token,
          clientId,
          locationId,
          foodTypeId: foodType.id,
          categoryId: category.id,
          payload,
        });
        showSnackbar("Item created successfully");
      }

      onSuccess();
      onClose();
    } catch (error) {
      showSnackbar(
        error?.response?.data?.detail || "Failed to save item",
        "error"
      );
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{mode === "edit" ? "Edit Item" : "Add Item"}</DialogTitle>

      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Node Type"
              value={form.node_type}
              onChange={(e) => setForm((p) => ({ ...p, node_type: e.target.value }))}
            >
              <MenuItem value="item">Item</MenuItem>
              <MenuItem value="item_group">Item Group</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={8}>
            <TextField
              fullWidth
              label="Parent Item ID (only for sub-item)"
              value={form.parent_item}
              onChange={(e) => setForm((p) => ({ ...p, parent_item: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Name"
              value={form.name}
              onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Badge"
              value={form.badge}
              onChange={(e) => setForm((p) => ({ ...p, badge: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Description"
              value={form.description}
              onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12}>
            <Button variant="outlined" component="label">
              Choose Image
              <input hidden type="file" accept="image/*" onChange={handleFileChange} />
            </Button>

            <Box sx={{ mt: 1 }}>
              <Typography variant="body2" color="text.secondary">
                {form.image
                  ? form.image.name
                  : data?.image
                  ? "Existing image available"
                  : "No image selected"}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Tags (comma separated)"
              value={form.tags}
              onChange={(e) => setForm((p) => ({ ...p, tags: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Ingredients (comma separated)"
              value={form.ingredients}
              onChange={(e) => setForm((p) => ({ ...p, ingredients: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              type="number"
              label="Pickup Price"
              value={form.pickup}
              disabled={form.node_type === "item_group"}
              onChange={(e) => setForm((p) => ({ ...p, pickup: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              type="number"
              label="Delivery Price"
              value={form.delivery}
              disabled={form.node_type === "item_group"}
              onChange={(e) => setForm((p) => ({ ...p, delivery: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              type="number"
              label="Dine-in Price"
              value={form.dine_in}
              disabled={form.node_type === "item_group"}
              onChange={(e) => setForm((p) => ({ ...p, dine_in: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              type="number"
              label="Display Order"
              value={form.display_order}
              onChange={(e) => setForm((p) => ({ ...p, display_order: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              type="number"
              label="Rating"
              value={form.rating}
              onChange={(e) => setForm((p) => ({ ...p, rating: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              type="number"
              label="Rating Count"
              value={form.rating_count}
              onChange={(e) => setForm((p) => ({ ...p, rating_count: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              type="number"
              label="Prep Time (mins)"
              value={form.prep_time_minutes}
              onChange={(e) =>
                setForm((p) => ({ ...p, prep_time_minutes: e.target.value }))
              }
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              type="number"
              label="Calories"
              value={form.calories}
              onChange={(e) => setForm((p) => ({ ...p, calories: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Discount Type"
              value={form.discount_type}
              onChange={(e) => setForm((p) => ({ ...p, discount_type: e.target.value }))}
            >
              <MenuItem value="">None</MenuItem>
              <MenuItem value="flat">Flat</MenuItem>
              <MenuItem value="percentage">Percentage</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="number"
              label="Discount Value"
              value={form.discount_value}
              onChange={(e) => setForm((p) => ({ ...p, discount_value: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <FormControlLabel
              control={
                <Switch
                  checked={form.is_available}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, is_available: e.target.checked }))
                  }
                />
              }
              label="Available"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={form.is_veg}
                  onChange={(e) => setForm((p) => ({ ...p, is_veg: e.target.checked }))}
                />
              }
              label="Veg"
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ItemDialog;